import { Link } from 'react-router-dom';
import { IBreadcrumbItem } from './breadcrumbs';

const crumb =
  'inline-flex min-w-0 items-center gap-1.5 rounded-md px-1.5 py-0.5';
const link = `${crumb} text-content-muted hover:bg-black/5 dark:hover:bg-white/10 hover:text-gray-900 focus-visible:ring-2 focus-visible:ring-gray-600 dark:focus-visible:ring-gray-400 focus-visible:ring-inset focus-visible:outline-none dark:hover:text-gray-100`;
const plain = `${crumb} text-content-muted`;
const current = `${crumb} font-medium text-gray-900 dark:text-gray-100`;

export const BreadcrumbItem = ({
  name,
  to,
  icon: Icon,
  isAnchor = false,
  content,
  isCurrent = false,
}: IBreadcrumbItem & { isCurrent?: boolean }) => {
  if (content) {
    return (
      <span
        className={isCurrent ? current : plain}
        aria-current={isCurrent ? 'page' : undefined}
      >
        {content}
      </span>
    );
  }
  // A crumb with no name (a page that puts its own control after the trail)
  // only needs the separator before it.
  if (!name && !Icon) {
    return null;
  }

  const label = (
    <>
      {Icon && <Icon className="size-4 shrink-0" />}
      {name && (
        // Earlier crumbs stop at 200px; the current one takes the room left.
        <span
          className={`${isCurrent ? '' : 'max-w-[200px]'} truncate`}
          title={name}
        >
          {name}
        </span>
      )}
    </>
  );

  if (isCurrent) {
    return (
      <span className={current} aria-current="page">
        {label}
      </span>
    );
  }
  if (!to) {
    return <span className={plain}>{label}</span>;
  }
  if (isAnchor) {
    return (
      <a href={to} className={link}>
        {label}
      </a>
    );
  }
  return (
    <Link to={to} className={link}>
      {label}
    </Link>
  );
};
